import '../../../../../scss/icons/icons.scss';
import './BeaconConfig.scss';
import { Text } from '@components';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { Button, Col, Container, Form, Row } from 'react-bootstrap';

function BeaconConfig({
  beacon,
  asset,
  onCreateConfig,
  goBack,
  onReasignQuestion,
  onSuccess,
  existingBeacons,
}) {
  const [isPrimary, setIsPrimary] = useState(false);

  const config = {
    isPrimary,
  };

  const renderWarning = () => {
    if (!beacon.assetName) return null;

    return (
      <div className="d-flex flex-column">
        <div className="sa mb-3">
          <div className="sa-warning mx-auto">
            <div className="sa-warning-body"></div>
            <div className="sa-warning-dot"></div>
          </div>
        </div>
        <Text variant="warning" className="fs-md text-center">
          Beacon {beacon.name} is already attached to Asset {beacon.assetName}. <br /> Clicking
          Confirm will add the Beacon to Asset {asset.name}
        </Text>
      </div>
    );
  };

  return (
    <Container className="d-flex flex-column justify-content-between h-100">
      <Row>
        <Col>
          <Form>
            <Form.Group className="">
              <Form.Label className="fs-lg">Will {beacon.name} be the Primary Beacon?</Form.Label>
              {/* New Assets & Assets without Beacons automatically set beacon attached as primary so check will be disabled and checked */}
              <Form.Check
                type="checkbox"
                label="Yes"
                checked={
                  isPrimary ||
                  asset.isCreated ||
                  (asset.beacons && asset.beacons.length === 0) ||
                  existingBeacons?.length === 0
                }
                onChange={(e) => setIsPrimary(e.target.checked)}
                disabled={
                  asset.isCreated ||
                  (asset.beacons && asset.beacons.length === 0) ||
                  existingBeacons?.length === 0
                }
              />
            </Form.Group>
          </Form>
        </Col>
      </Row>

      <Row>
        <Col>{renderWarning()}</Col>
      </Row>

      <Row>
        <Col>
          <div className="d-flex flex-row justify-content-center">
            <Button variant="secondary" className="my-2 back-btn" onClick={goBack}>
              Back
            </Button>
          </div>

          <div className="d-flex flex-row justify-content-center">
            <Button
              variant="primary"
              className="my-2 confirm-btn"
              onClick={
                Boolean(beacon?.assetName)
                  ? () => {
                      onReasignQuestion();
                      onCreateConfig(config);
                    }
                  : () => {
                      onCreateConfig(config);
                      onSuccess();
                    }
              }
            >
              Submit
            </Button>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

BeaconConfig.propTypes = {
  beacon: PropTypes.object.isRequired,
  onClickNext: PropTypes.func,
  onCreateConfig: PropTypes.func.isRequired,
};

export default BeaconConfig;
